module.exports = __webpack_public_path__ + "img/child-of-love1.a70b0de1.jpg";